import React from "react";
import defaultSrc from '../../assets/default.jpg'

const Default = props => (
    <div>
        <img style={{ width: 200, height: 250}} alt="Default Icon" src={defaultSrc} />
    </div>
);

export default Default;